/**
 * PATH: apps/inventory/src/pages/emptyRegister.tsx
 * PURPOSE: Empty state for inventory pages that have no stock API.
 */
export function EmptyRegister({ title, detail }: { title: string; detail: string }) {
  return (
    <div className="space-y-2">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">{title}</h1>
      <p className="text-gray-500 dark:text-gray-400">{detail}</p>
    </div>
  )
}
